import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Typography } from '../../../../components/Wrappers/Wrappers';
import { useStyles } from './faqSection.styles';

const FAQ_ITEMS = [
    {
        id: 'what-is-connect',
        q: 'What is Connect?',
        a: "Turn your high-intent data into high-impact marketing. ECAL Connect allows you to directly connect your ECAL audience data to the data, marketing and AI platforms you rely on everyday. Build deeper audience profiles, better understand behaviours, create amazing workflows, and deliver on personalisation like never before. Over 50+ popular integrations. Easily connect to over 50 popular data, mail, marketing, CDP, CRM, productivity and AI platforms. No more CSVs. No integration headache. No middleware.",
    },
    {
        id: 'dds-comparison',
        q: 'How is this different from the old DDS service?',
        a: "DDS delivers data files to SFTP or S3, from which the publisher needs to implement an additional service to send this data to where it needs to go. Connect delivers the same data directly into the client's chosen data, marketing or AI platform on an automated schedule.",
    },
    {
        id: 'over-limit',
        q: 'What if a client goes over their plan limit?',
        a: 'A publisher can choose to purchase extra transactions at $25 per 1,000 transactions across all plans. This adds an extra 1,000 transactions to the plan limit, which will reset at its normal monthly frequency. Any unused extra transaction credits are lost.',
    },
    {
        id: 'move-between-plans',
        q: 'Can a client move between plans?',
        a: 'Yes. A publisher can upgrade or downgrade a plan at any time. Please note, the upgrade or downgrade will take effect from next renewal.',
    },
    {
        id: 'setup-fees',
        q: 'Are there setup fees?',
        a: 'No. There is no set-up fee on any plan. Set-up is self-managed by the publisher.',
    },
    {
        id: 'multi-year-discounts',
        q: 'Are there multi-year discounts?',
        a: 'No, this is not available directly via the data plans, but maybe possible as part of an overall contract negotiation with the sales team.',
    },
    {
        id: 'available-integrations',
        q: 'What integrations are available?',
        a: "All plans have access to the full integrations marketplace, including premium apps, LLM's and custom apps other publishers have requested and become listed. Custom integrations are available on the Growth plan (1 in total) and the Enterprise plan (3 in total).",
    },
    {
        id: 'sync-frequency',
        q: 'How frequent is the data sync?',
        a: 'Connector syncs weekly or monthly. Growth and Enterprise syncs daily, weekly or monthly. *Sync frequency options may vary for some integrations.',
    },
    {
        id: 'sync-transaction',
        q: 'What counts as a sync transaction?',
        a: 'A sync transaction is one complete user record delivered into one of their integrations through ECAL Connect, such as their data lake or CDP. If they are connected to two integrations, then that same user record will be sent twice (once to each integration) and count as two transactions.',
    },
];

function ConnectFaqSection () {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(null);

    function handleChange (id) {
        return () => setExpanded((current) => (current === id ? null : id));
    }

    return (
        <div>
            <Typography variant="h5" weight="bold" style={{ fontSize: 22 }} className={classes.heading}>
                Frequently Asked Questions
            </Typography>

            <div className={classes.list}>
                {FAQ_ITEMS.map((item) => (
                    <Accordion
                        key={item.id}
                        expanded={expanded === item.id}
                        onChange={handleChange(item.id)}
                        className={classes.accordion}
                        elevation={0}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`${item.id}-content`}
                            id={`${item.id}-header`}
                            className={classes.summary}
                        >
                            <Typography variant="subtitle1" weight="bold" className={classes.question}>
                                {item.q}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.details}>
                            <Typography variant="body2" className={classes.answer}>
                                {item.a}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
        </div>
    );
}

export default ConnectFaqSection;
